import styled from "@rentiohq/web-theme";

export const ChecklistProgressWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
